import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class AdministratorContainer extends ShadowDOMElement {
	static className = "AdministratorContainer";
	
	render() {
    return html`
      <div class="mb-3">
        <title-field label="Nominations"></title-field>
        <big-checkbox-field
          label="Administrateur"
          name="administrateur"
          id-input="chkAdministrateur"
		  id="chk-administrateur"
          @change="${this.handleAdminCheckboxChange}"
        ></big-checkbox-field>
        <div-container id="main-div-container" visible="false">
          <checkbox-field
              label="Personne physique"
              id-input="chkPersonnePhysique"
			  id="chk-personne-physique"
              name="personne_physique"
              @change="${this.handlePhysiqueCheckboxChange}"
          ></checkbox-field>
          <administrator-personne-physique-list id="container-physique" visible="false"></administrator-personne-physique-list>
          <checkbox-field
              label="Personne morale"
              id-input="chkPersonneMorale"
			  id="chk-personne-morale"
              name="personne_morale"
              @change="${this.handleMoraleCheckboxChange}"
          ></checkbox-field>
          <administrator-personne-morale-list id="container-morale" visible="false"></administrator-personne-morale-list>
		  <subtitle-field label="Première réunion du conseil d'administration"></subtitle-field>
		  <row-wrapper>
		  	<date-field label="Date *" required name="date"></date-field>
		  </row-wrapper>
		  <row-wrapper>
		  	<text-field label="Lieu *" required name="location"></text-field>
		  </row-wrapper>
		  <subtitle-field label="Ont été nommés"></subtitle-field>
		  <president-container></president-container>
		  <director-container></director-container>
        </div-container>
      </div>
    `;
	}

	handleAdminCheckboxChange(event) {
		const container = this.shadowRoot.querySelector ("div-container");
		container.visible = event.target.checked;
	}

	handlePhysiqueCheckboxChange(event) {
		const personnePhysiqueList = this.shadowRoot.querySelector ("administrator-personne-physique-list");
		personnePhysiqueList.visible = event.target.checked;
	}

	handleMoraleCheckboxChange(event) {
		const personneMoraleList = this.shadowRoot.querySelector ("administrator-personne-morale-list");
		personneMoraleList.visible = event.target.checked;
	}
	
	isTransient (){
		return false;
	}
	
	#updateContainers (){
		const container1Visible = this.shadowRoot.querySelector ("#chk-administrateur").checked;
		const container2Visible = this.shadowRoot.querySelectorAll ("#chk-personne-physique")[0].checked;
		const container3Visible = this.shadowRoot.querySelectorAll ("#chk-personne-morale")[0].checked;

		this.shadowRoot.querySelector ("#main-div-container").visible = container1Visible;
		this.shadowRoot.querySelectorAll ("#container-physique")[0].visible = container2Visible;
		this.shadowRoot.querySelectorAll ("#container-morale")[0].visible = container3Visible;
	}
	
	setValues (values){
		super.setValues (values);
		this.#updateContainers ();
		this.requestUpdate ();
	}
}

customElements.define("administrator-container", AdministratorContainer);
